import fetch from '@/common/js/http';

const department = {
    namespaced: true,
    state: {},
    mutations: {},
    actions:{
        getDeptInfo({commit},params){
            return new Promise((resolve,reject)=>{
                return fetch({
                    url:'dept/page',
                    method: 'get',
                    params:params
                }).then(success=>{
                    resolve(success)
                },error=>{
                    reject(error)
                })
            })
        },
        addDeptInfo({commit},params) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'dept',
                    method: 'post',
                    data:params
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        editDeptInfo({commit},params) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'dept',
                    method: 'put',
                    data:params
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        getAllDeptInfo({commit}){
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'dept/all',
                    method: 'get',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        }
    }
}

export default department;


// WEBPACK FOOTER //
// ./src/vuex/modules/department.js